import React from "react";
import Lap from "../assets/images/svg/ComingSoon/LapMobile.svg";

const CurvedHeader = () => {
  return (
    <div className="curved-wrapper">
      <div className="curved-shape">

        {/* Title */}
        <h1 className="curved-shape-text text-center">
          Coming Soon
        </h1>

        {/* Content */}
        <div className="container">
          <div className="row align-items-center justify-content-center text-center text-lg-start">

            {/* Image */}
            <div className="col-lg-5 col-md-6 col-12 mb-4 mb-lg-0 text-center">
              <img
                src={Lap}
                alt="App Preview"
                className="img-fluid app-img"
              />
            </div>

            {/* Text */}
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="text-light mb-3 pe-4 me-2">
                Doctor Web Portal & Companion Mobile App
              </h4>

              <p className="text-light">
                We’re bringing a smarter, connected experience for healthcare
                professionals and companions alike. Doctors can effortlessly
                manage schedules, monitor patient adherence, and coordinate
                care, while companions can actively support the health journey
                of their loved ones – all through an intuitive web portal or
                companion mobile app.
              </p>
            </div>

          </div>
        </div>

        {/* Tagline */}
        <h5 className="text-light tagline text-center mt-4">
          Stay connected, stay informed – launching soon!
        </h5>

      </div>
    </div>
  );
};

export default CurvedHeader;
